module.exports = __webpack_public_path__ + "static/img/Geos-2022-Oscar.82bd8cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Oscar.png
// module id = 9GZ6
// module chunks = 0